/**
	Это плагин для подсказки с вопросительным знаком в кружке (?)
	см. также tooltipHandler в common2019.js
	см. также front/src/css/theme/tooltip-ask.less
	Проверка в АРМ https://new-www.local.oooinex.ru/uarm-fe/#/card/107/1043/291309
	Проверка на морде https://new-www.local.oooinex.ru/ru/9284/page/3102?id=291309
*/

/* eslint-disable */
/*global tinymce:true */

(function () {
	let tooltip = (function () {
		'use strict';

		const global = tinymce.util.Tools.resolve('tinymce.PluginManager');

		const global$1 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

		const getMinWidth = function (editor) {
			return editor.getParam('tooltip_dialog_width', 300);
		};
		const getMinHeight = function (editor) {
			return editor.getParam('tooltip_dialog_height', Math.min(global$1.DOM.getViewPort().h, 100));
		};

		const Settings = {
			getMinWidth: getMinWidth,
			getMinHeight: getMinHeight,
		};

		const setContent = function (editor, html) {
			editor.focus();
			editor.undoManager.transact(function () {
				editor.setContent(html);
			});
			editor.selection.setCursorLocation();
			editor.nodeChanged();
		};
		const getContent = function (editor) {
			return editor.getContent({ source_view: true });
		};

		function getSelectedContent (editor) {
			let existingTooltipDescr;
			let existingPositionClass;

			const selNode = editor.selection.getNode(); // нода в которую ткнули
			const selText = editor.selection.getSel()?.toString?.(); // выделенный текст

			if (selNode) {
				const askNode = selNode.classList.contains('tooltip-ask') ? selNode : selNode.closest('.tooltip-ask'); // ищем обертку тултипа (ткнули-то наверняка в элемент внутри него)

				if (askNode) {
					existingTooltipDescr = askNode?.querySelector?.('.tooltip-ask__content')?.innerHTML;
					existingPositionClass = getPositionClass(askNode);
				}
			}



			return {
				// в текст передаём тупо выбранный текст либо текст из тултипа, на котором стоит курсор
				tooltipDescr: existingTooltipDescr || selText || '',
				tooltipPositionClass: existingPositionClass || '',
			};
		};

		function getPositionClass (selNode) {
			const possibleClassList = positionValues.map(pv => pv.value);
			const defaultClass = possibleClassList[0];

			let selectedClass;
			possibleClassList.forEach(cls => {
				if (selNode.classList.contains(cls)) {
					selectedClass = cls;
				}
				else if (selectedClass) {
					// если один найден, остальные удаляем (ну вдруг несколько)
					selNode.classList.remove(cls);
				}
			})
			return selectedClass || defaultClass;
		}

		const Content = {
			setContent,
			getContent,
			getSelectedContent,
		};

		const positionValues = [
			{ text: 'Сверху справа', value: 'tooltip-ask_pos-top-right' },
			{ text: 'Сверху слева', value: 'tooltip-ask_pos-top-left' },
			{ text: 'Снизу справа', value: 'tooltip-ask_pos-bottom-right' },
			{ text: 'Снизу слева', value: 'tooltip-ask_pos-bottom-left' },
		]

		function makeTooltip (submitData) {
			const { tt_ctrl_position, tt_ctrl_text } = submitData;
			const tooltipText = `
			<span data-test-id="tooltip-block" class="tooltip-ask ${tt_ctrl_position}" role="button" tabindex="0" aria-label="Описание">
				<span class="tooltip-ask__icon print-hide" aria-hidden="true" role="presentation">?</span>
				<span class="tooltip-ask__content print-show">${tt_ctrl_text}</span>
			</span>
			`;
			return tooltipText;
		};

		const removeTooltip = function (editor, clear) {
			let selNode = editor.selection.getNode();
			if (selNode) {
				const askNode = selNode.classList.contains('tooltip-ask') ? selNode : selNode.closest('.tooltip-ask');
				replaiceText(editor, askNode, clear);
			}
		};

		function replaiceText (editor, node, clear) {
			if (!node) return;
			editor.undoManager.transact(function () {
				let newSpan = document.createElement('span');
				let tooltipText;
				if (!clear) {
					tooltipText = node.getElementsByClassName('tooltip-ask__content')[0].innerHTML;
					newSpan.innerHTML = tooltipText;
				}
				node.parentNode.replaceChild(newSpan, node);
			});

			editor.nodeChanged();
		}

		var open = function (editor) {
			var minWidth = Settings.getMinWidth(editor);
			var minHeight = Settings.getMinHeight(editor);

			var win = editor.windowManager.open({
				layout: 'flex',
				title: 'Tooltip',
				body: [{
					type: 'textbox',
					name: 'tt_ctrl_text',
					multiline: true,
					minWidth: minWidth,
					minHeight: minHeight,
					spellcheck: false,
					style: 'direction: ltr; text-align: left',
				},
				{
					type: 'listbox', // не combobox!
					name: 'tt_ctrl_position',
					label: 'Расположение',
					values: positionValues,
				}],
				onSubmit: function (evt) {
					removeTooltip(editor, true);
					editor.insertContent(makeTooltip(evt.data));
					editor.undoManager.add();
				},
			});
			const dataToSet = Content.getSelectedContent(editor);

			win.find('#tt_ctrl_text').value(dataToSet.tooltipDescr);
			win.find('#tt_ctrl_position').value(dataToSet.tooltipPositionClass);
		};
		var Dialog = { open: open };

		var register = function (editor) {
			editor.addCommand('mceCodeEditor', function () {
				Dialog.open(editor);
				editor.undoManager.add();
			});
		};
		var Commands = { register: register };

		var register$1 = function (editor) {
			editor.addButton('tooltip', {
				image: '/uarm-fe/uarm-images/tooltip.svg',
				tooltip: 'Tooltip',
				onclick: function () {
					Dialog.open(editor);
					editor.undoManager.add();
				},
			});
			editor.addButton('tooltip-remove', {
				image: '/uarm-fe/uarm-images/tooltip-remove.svg',
				tooltip: 'Tooltip remove',
				onclick: function () {
					removeTooltip(editor);
					editor.undoManager.add();
				},
			});
		};
		var Buttons = { register: register$1 };

		global.add('tooltip', function (editor) {
			Commands.register(editor);
			Buttons.register(editor);

			return Content;
		});
		function Plugin () { }

		return Plugin;
	})();
})();
